import "./providers";
import { getActiveProvider } from "./registry";
import type { AnalyticsIdentifyContext } from "./types";
import logger from "@utils/logger";

export async function identifyUser(context: AnalyticsIdentifyContext): Promise<void> {
  logger._console.log("[analytics] identifyUser", { memberId: context.member?.id });
  await getActiveProvider()?.identify(context);
}

export async function resetAnalyticsUser(): Promise<void> {
  logger._console.log("[analytics] resetAnalyticsUser");
  await getActiveProvider()?.reset();
}

